import {CommonResponse, BaseRequestParams, GetParamsType, GetSingleParamsType, instance} from "./API"
import {AxiosResponse} from "axios"
import {filterToString} from "../helps/filterToString"
import {CompaniesResponse, CompanyResponse} from "../models/response"

export const companyApi = {
    getCompanies(params?: GetParamsType & {excludeSystem?: boolean}): Promise<CommonResponse<CompaniesResponse>> {
        const paramsString = filterToString(params)
        return instance.get(`company${paramsString}`, {signal: params?.controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    getCompany(params: GetSingleParamsType): Promise<CommonResponse<CompanyResponse>> {
        const {id, controller} = params
        return instance.get(`company/${id}`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    createCompany(form: CreateCompanyType): Promise<CommonResponse<CompanyResponse>> {
        const {controller, ...rest} = form
        return instance.post(`company`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    changeCompany(form: ChangeCompanyType): Promise<CommonResponse<CompanyResponse>> {
        const {id, controller, ...rest} = form
        return instance.put(`company/${id}`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    deleteCompany(id: number): Promise<CommonResponse<boolean>> {
        return instance.delete(`company/${id}`).then((res: AxiosResponse) => res.data)
    },
}

export type CreateCompanyType = {
    name: string
    active: boolean
    requisites: string
    comment: string
} & BaseRequestParams

export type ChangeCompanyType = {
    id: number
} & CreateCompanyType